const Index = () => import(/* webpackChunkName: "knowledge" */'@/components/pages/notice/Index.vue');
const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');

export default [
  {
    path: '/notice',
    component: Layout,
    meta: {
      roles: ['NOTIFICATION_QUERY'],
    },
    children: [{
      path: '',
      name: 'notice',
      component: Index,
      meta: {
        roles: [],
        title: '公告通知',
        icon: 'announce',
        activeMenu: '/notice',
        componentName: 'Notice',
        breadcrumb: [
          {
            name: '首页',
            path: '/home'
          },
          {
            name: '公告通知',
            path: '/notice'
          }
        ]
      }
    }]
  }
];



// WEBPACK FOOTER //
// ./src/router/notice.js